import React, { useContext } from "react"
import { Navigate } from "react-router-dom"
//import { AuthContext } from '../contexts/AuthContext'
import { connect, useSelector } from 'react-redux'
import { isLoaded, isEmpty } from 'react-redux-firebase';

// export default function PrivateRoute({ component: Component, ...rest }) {
//   const { currentUser } = useContext(AuthContext)

//   return (
//     <Routes>
//         <Route
//         {...rest}
//         render={props => {
//             return currentUser ? <Component {...props} /> : <Navigate to="/login" />
//         }}
//         ></Route>
//     </Routes>
//   )
// }


function PrivateRoute({ children, ...rest }) {
    //const { currentUser } = useContext(AuthContext)
    const puid = useSelector((state) => state.firebase.auth)
    //console.log(puid);
    //console.log(isEmpty(puid));

    if (!isLoaded(puid)){
        return (
          <div>Loading...</div>
        )
      } else {
        return (!isEmpty(puid)) ? children : <Navigate to="/login" />
    }    

    // return (
    //     // {...rest}
    //     // ()={props => {
    //     //     return currentUser ? children({...props}) : <Navigate to="/login" />
    //     // }
    //     // }ß
    //     //return currentUser ? children({...rest}) : <Navigate to="/login" />
    // )
    //return currentUser ? children : <Navigate to="/login" />
    //return puid ? children : <Navigate to="/login" />
    //return (puid && puid.uid) ? children : <Navigate to="/login" />
  
}

const mapStateToProps = (state) => {
    //console.log(state);
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile
    }
}

export default connect(mapStateToProps)(PrivateRoute)